import React from 'react';

export const PHONE_SLOTS = [
  { slot: 1 as const, profile: 'CELULAR1' as const },
  { slot: 2 as const, profile: 'CELULAR2' as const },
  { slot: 3 as const, profile: 'CELULAR3' as const },
];

export type PhoneSlotId = 1 | 2 | 3;
export type PhoneSlotProfile = 'CELULAR1' | 'CELULAR2' | 'CELULAR3';

type PhoneSlotStripProps = {
  /** Profiles com janela aberta (visível, não minimizada). */
  activeProfiles?: string[];
  onToggle: (slot: PhoneSlotId, profile: PhoneSlotProfile) => void;
  className?: string;
  size?: 'sm' | 'md';
};

const PhoneIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="7" y="2" width="10" height="20" rx="2" />
    <line x1="12" y1="18" x2="12.01" y2="18" />
  </svg>
);

/** Três ícones fixos (1–3) para abrir/fechar janelas mobile. */
export const PhoneSlotStrip: React.FC<PhoneSlotStripProps> = ({
  activeProfiles = [],
  onToggle,
  className = '',
  size = 'md',
}) => {
  const btn = size === 'sm' ? 'w-8 h-8' : 'w-9 h-9';
  const num = size === 'sm' ? 'text-[8px]' : 'text-[9px]';

  return (
    <nav
      className={`flex items-center gap-1 p-1 bg-black/25 border border-white/5 rounded-2xl ${className}`}
      aria-label="Celulares do simulador"
    >
      {PHONE_SLOTS.map(({ slot, profile }) => {
        const isActive = activeProfiles.includes(profile);
        return (
          <button
            key={profile}
            type="button"
            onClick={() => onToggle(slot, profile)}
            title={isActive ? `Fechar Celular ${slot}` : `Abrir Celular ${slot}`}
            className={`${btn} rounded-xl flex items-center justify-center relative cursor-pointer transition-all active:scale-90 hover:scale-105 border-none ${
              isActive
                ? 'text-white bg-[#89b4fa]/25'
                : 'text-[#9aa3c0] hover:text-white hover:bg-white/5 bg-transparent'
            }`}
            style={
              isActive
                ? {
                    boxShadow:
                      'inset 0 0 0 1px rgba(137, 180, 250, 0.35), 0 4px 12px rgba(137, 180, 250, 0.18)',
                  }
                : undefined
            }
          >
            <span
              className={`absolute top-0.5 left-1 ${num} font-black leading-none tabular-nums ${
                isActive ? 'text-[#89b4fa]' : 'text-[#585b70]'
              }`}
            >
              {slot}
            </span>
            <span className="mt-0.5">
              <PhoneIcon className={size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4'} />
            </span>
            {isActive && (
              <span className="absolute bottom-[3px] left-[25%] right-[25%] h-[2px] rounded-full bg-[#89b4fa] shadow-[0_0_6px_#89b4fa]" />
            )}
          </button>
        );
      })}
    </nav>
  );
};
